import { apiClient } from '@/services/base'
import { useMutation, UseMutationResult } from '@tanstack/react-query'

import { IMultiTenantAuthenticationRequest } from './interfaces/request'
import { IMultiTenantAuthenticationResponse } from './interfaces/response'

export const MultiTenantAuthenticationService = async (
  request: IMultiTenantAuthenticationRequest,
): Promise<IMultiTenantAuthenticationResponse> => {
  const response = await apiClient.post(
    'api/Login/MultiTenantAuthentication',
    request,
  )

  return response?.data
}

export const useMultiTenantAuthenticationService = (): UseMutationResult<
  IMultiTenantAuthenticationResponse,
  Error,
  IMultiTenantAuthenticationRequest
> => {
  return useMutation<
    IMultiTenantAuthenticationResponse,
    Error,
    IMultiTenantAuthenticationRequest
  >({
    mutationFn: MultiTenantAuthenticationService,
  })
}

export type {
  IMultiTenantAuthenticationRequest,
  IMultiTenantAuthenticationResponse,
}
